import { StoryModel } from '../models/story.model';
import { ContentType } from '../models/content-type.enum';

export class StoryStateModel {
    loading: boolean;
    incoming: {
        id: string,
        type: ContentType
    };
    story?: StoryModel;
    storyId: string; // current storyId
    storyType: ContentType;
    loadChunks: StoryChunkLoadModel[];
    loadChunksRemaining: StoryChunkLoadModel[];
    loadingChunk: StoryChunkLoadModel;
    thumbnailLookup: {
        originalChapterId: string, 
        newChapterId: string, 
        originalStoryId: string
    }[];
}

export class StoryChunkLoadModel {
    chunkId: string;
    storyId: string;
    chapterId: string;
    time?: number;
    objects: string[];
    assetTypes: string[];
    activate: boolean;
    activationConfig?: StoryChapterLoadProtocolModel;
    readyState: {
        model?: boolean;
        animation?: boolean;
    };
}

export class StoryLoadConfigModel {
    targetChapterId:  string;
    targetChapterConfig: {
        global: StoryChapterLoadProtocolModel,
        static: StoryChapterLoadProtocolModel,
        dynamic: StoryChapterLoadProtocolModel
    };
    chapterAssetBundle: boolean;
    sortBy: 'chapter' | 'readyState';
}

export class StoryChapterLoadProtocolModel {
    timeline?: boolean;
    camera?: boolean;
    graph?: boolean;
    properties?: boolean;
    particles?: boolean;
    clipping?: boolean;
    postprocess?: boolean;
    transparencyMode?: boolean;
    labels?: boolean;
}
